/**
 * @file stripeClient.ts
 * @brief Lazy Stripe.js loader for the web panel.
 *
 * @details
 * The test-mode developer assistant (floating "stripe ›" button) is turned
 * off (DES 21-10-2026).
 *
 * @author DES
 * @date 19-06-2026
 */

import { loadStripe, type Stripe } from "@stripe/stripe-js";
import { env } from "@/shared/config/env";

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!env.stripePublishableKey) {
    return Promise.resolve(null);
  }
  if (!stripePromise) {
    // Stripe.js shows a floating "stripe ›" assistant button with a test key.
    // Users must never see it, so it is off everywhere (21-10-2026).
    stripePromise = loadStripe(env.stripePublishableKey, { developerTools: { assistant: { enabled: false } } });
  }
  return stripePromise;
}

export function isStripeConfigured(): boolean {
  return Boolean(env.stripePublishableKey);
}
